export default function getInitialValues(employer) {
	let industryEligibilityConfirmed = false;
	if (employer?.eligibleIndustryCertificationTs) {
		industryEligibilityConfirmed = true;
	}
	return {
		displayName: employer?.displayName,
		addressLine1: employer?.addressLine1,
		addressLine2: employer?.addressLine2,
		city: employer?.city,
		state: employer?.state,
		zip: employer?.zip,
		ein: employer?.ein,
		registrationType: employer?.registrationType,
		registrationState: employer?.registrationState,
		email: employer?.email,
		contactFirstName: employer?.contactFirstName,
		contactLastName: employer?.contactLastName,
		phone: employer?.phone,
		website: employer?.website,
		industryEligibilityConfirmed: industryEligibilityConfirmed,
		// rootAdminEmail:employer?.rootAdmin?.email || "",
		// rootAdminFirstName:employer?.rootAdmin?.firstName || "",
		// rootAdminLastName:employer?.rootAdmin?.lastName || "",
		// rootAdminPhone:employer?.rootAdmin?.phone || "",

	}
}
